import { getMonth, getYear } from "date-fns";


export const calculateActiveusersPerMonth = (
    list: any[]
): any[] => {

    const result: any[] = [];

    list.forEach((value) => {
        if (value.created_date) {
            const month = getMonth(value.created_date);
            //  console.log(month)
            const year = getYear(value.created_date);
            //console.log(year);
            const productCode = value.product_code;
            const resultIndex = result.findIndex(
                (value) => value.month === month && value.year === year && value.productCode === productCode
            );

            if (resultIndex >= 0) {
                result[resultIndex].total.active_users += value.active_users || 0;
                result[resultIndex].total.unique_active_users += value.unique_active_users || 0;
            } else {
                result.push({
                    month,
                    year,
                    productCode,
                    total: {
                        active_users: value.active_users || 0,
                        unique_active_users: value.unique_active_users || 0,
                    },
                });
            }
        }
    });

    return result;
};

export const PRODUCT_GRAPH_COLOR: any = {
    ACCOUNT: "red",
    API_SERVICE: "blue",
    MATTERHORN: "#00768B",
    CONTROL_CENTER: "#000000",
    DESIGNSHOP: "#DC4D01",
    EFS: "brown",
    FUSION: "#ff3fde"
}